export default __webpack_public_path__ + "static/media/hero_overlay.c19bedfa.png";